import { Injectable, inject } from '@angular/core';
import { ErrorHandler } from '@angular/core';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
  private readonly errorHandlerService = inject(ErrorHandlerService);

  handleError(error: unknown): void {
    console.error('[GLOBAL ERROR HANDLER]:', error);
    // Error reporting must never throw: otherwise the reporting failure masks the
    // original exception and creates a noisy global-error loop.
    try {
      this.errorHandlerService.handleError(error);
    } catch (reportingError) {
      console.error('[GLOBAL ERROR REPORTING FAILED]:', reportingError);
    }
  }
}
